module.exports = __webpack_public_path__ + "media/images/surveyadefault-c52bbf2d.png";